<div class="container">
    <div class="segments">
        <div [@leftBackground]="closed ? 'closed' : 'not-closed'" (@leftBackground.done)="done($event)" class="left-segment">
        </div>
        <div [@rightBackground]="closed ? 'closed' : 'not-closed'" (@rightBackground.done)="done($event)" class="right-segment">
        </div>
    </div>
    <div class="logo-container">
        <div class="left-image-wrapper">
            <div
                class="left-image-animation-box"
                [@leftImage]="closed ? 'closed' : 'not-closed'"
                (@leftImage.done)="done($event)"
            >
                <img class="logo logo-left" src="assets/img/transition/SO.webp">
            </div>
        </div>
        <div class="right-image-wrapper">
            <div
                class="rigth-image-animation-box"
                [@rightImage]="closed ? 'closed' : 'not-closed'"
                (@rightImage.done)="done($event)"
            >
                <img class="logo logo-right" src="assets/img/transition/PO.webp">
            </div>
        </div>
    </div>
</div>
